import { useIsomorphicLayoutEffect } from '@cian/react-utils';
import { Close16 } from '@cian/ui-kit/icons';
import { ModalFullscreen } from '@cian/ui-kit/modal';
import * as React from 'react';

import * as styles from './GalleryFullscreen.css';
import { TMedia } from '../../types';
import { GalleryInner } from '../GalleryInner';

interface IGalleryFullscreenSlots {
  slotBefore?: React.ReactNode;
  slotSidebar?: React.ReactNode;
}

interface IGalleryFullscreenProps extends IGalleryFullscreenSlots {
  media: TMedia[];
  initialSlide?: number;
  open?: boolean;
  onSlideChange?(index: number): void;
  onClose?(): void;
}

export const GalleryFullscreen: React.FC<IGalleryFullscreenProps> = ({
  slotBefore,
  slotSidebar,
  media,
  initialSlide,
  open,
  onSlideChange,
  onClose,
}) => {
  const galleryInnerRef = React.useRef<React.ElementRef<typeof GalleryInner>>(null);

  useIsomorphicLayoutEffect(() => {
    /* istanbul ignore next */
    if (open && initialSlide) {
      galleryInnerRef.current?.scrollTo(initialSlide, { behavior: 'auto' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <ModalFullscreen escape open={open} theme="white" onClose={onClose}>
      <button
        data-name="GalleryFullscreenClose"
        className={styles['close']}
        title="Закрыть полноэкранную галерею"
        onClick={onClose}
      >
        <Close16 display="block" color="white_100" />
      </button>
      <div data-name="GalleryFullscreen" className={styles['container']}>
        {slotBefore}
        <div className={styles['inner']}>
          <GalleryInner
            ref={galleryInnerRef}
            media={media}
            objectFit="contain"
            thumbsBounded
            videoPlayable
            onSlideChange={onSlideChange}
          />
          {slotSidebar}
        </div>
      </div>
    </ModalFullscreen>
  );
};
